import { Component, OnInit, ViewEncapsulation, Input, ChangeDetectorRef } from "@angular/core";
import { delay, SharedService } from '../../shared'
import { IQuestionnaireSection, IQuestionnaireSubSection, ISymptomeObj, EnumSectionStatus, LANGUAGE_ENUM } from '../questionnaire.model';
import { Options } from '@angular-slider/ngx-slider';


@Component({
    selector: 'symptome',
    templateUrl: "./symptome.component.html",
    styleUrls: ["./symptome.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class SymptomeComponent implements OnInit {
    @Input() LANGUAGE: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;
    @Input() section: IQuestionnaireSection = null;
    @Input() subSection: IQuestionnaireSubSection = null;
    @Input() symptomes: ISymptomeObj[] = [];
    @Input() status: EnumSectionStatus = EnumSectionStatus.ACTIVE;

    LANGUAGE_ENUM = LANGUAGE_ENUM;

    EnumSectionStatus = EnumSectionStatus;

    get sliderOptions(): Options {
        return {
            floor: 0,
            ceil: 10,
            showSelectionBar: false,
            step: 1,
            showTicks: true,
            showTicksValues: true,
            disabled: this.status == EnumSectionStatus.COMPLETED ? true : false
        }
    };

    constructor(private cd: ChangeDetectorRef,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {

    }

    fnToggleFreeText(symptome: ISymptomeObj) {
        symptome.showFreeText = !symptome.showFreeText;
    }
}
